import React from "react";
import { object, number } from "prop-types";
import get from "lodash.get";
import { Link } from "@quintype/components";

import Cardimage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";

import "./story-card17.m.css";

function StoryCard17({ story, headerType, headerLevel, lineClamp, type = "a" }) {
  const { slug, headline } = story;
  const section = get(story, ["sections", 0], {});
  const sectionName = get(section, ["display-name"]) || get(section, ["name"]);

  return (
    <Link href={`/${slug}`}>
      <div styleName="wrapper" id="story-card-17">
        <div styleName={`card-image-${type}`}>
          <Cardimage
            story={story}
            aspectRatio={type === "b" ? [16, 9] : [1, 1]}
            imageType={type === "b" ? "image16x9" : "image1x1"}
            showVideoIcon={true}
            widths={[100, 128]}
          />
        </div>
        <div styleName={`heading-${type}`}>
          {story["story-template"] === "sponsored" || story["story-template"] === "brandspot-client-story" ? (
            <div styleName="title">Featured Content</div>
          ) : (
            <div styleName="title">{sectionName !== "" ? sectionName : null}</div>
          )}
          <Headline
            text={headline}
            headerType={headerType}
            headerLevel={headerLevel}
            lineClamp={lineClamp}
            story={story}
          />
        </div>
      </div>
    </Link>
  );
}

StoryCard17.defaultProps = {
  headerType: 2,
  headerLevel: 3,
  lineClamp: 2
};

StoryCard17.propTypes = {
  story: object.isRequired,
  headerType: number,
  headerLevel: number,
  lineClamp: number
};

export default StoryCard17;
